import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import CommentIcon from '@material-ui/icons/Comment';
import GridIcon from '@material-ui/icons/GridOn';
import InfoIcon from '@material-ui/icons/Info';
import Collapse from '@material-ui/core/Collapse';
import { createMuiTheme, MuiThemeProvider  } from '@material-ui/core/styles'
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Badge from '@material-ui/core/Badge';

import IconDownload from '../assets/download.svg'

import FilterListIcon from '@material-ui/icons/FilterList';

const styles = theme => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  bold: {
    fontWeight:'bold'
  },
  badge: {
    backgroundColor: '#777'
  },
  subtitle: {
    borderBottom: 'solid 1px'
  },
  filterOn: {
    backgroundColor: 'rgba(0, 0, 0, 0.54)',
    color: '#fff'
  }
});

const theme = createMuiTheme({
  overrides: {
    MuiCheckbox: {
      colorSecondary: {
        //color:'black',
        '&$checked': { // <-- mixing the two classes
          color: 'rgba(0, 0, 0, 0.87)',
        }
      }
    },
    MuiList: {
     padding: {
        paddingTop:0,
        //paddingBottom:0
      }
    },
    MuiListItem: {
      secondaryAction: {
        paddingRight: '12px'
      },
      dense: {
        paddingTop:0,
        paddingBottom:0
      }
    },
    MuiListItemText: {
      root: {
        paddingRight:'20px'
      }
    },
    MuiIconButton:
    {
      root: {
        padding: '5px'
      }
    }
  }
})

class CheckboxList extends React.Component {
  state = {
    checked: [0],
    collapsed: [0],
    filtered: [0],
    open: true
  };

  initialized = false;
  filteredItemsInitialized = false;

  toggleState = (value, whichState, fun) => {
    const checked = this.state[whichState];
    const currentIndex = checked.indexOf(value.key);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value.key);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    this.setState({
      [whichState]: newChecked,
    }, fun);
  }

  handleFilterToggle = (item, filtered, checked) => {
    this.toggleState(item, 'filtered', function () {
      this.props.handleLayerFilterClick(item, filtered, checked);
    });
  }

  handleToggle = (value, checked) => () => {
    this.toggleState(value, 'checked', function() {
        this.props.handleLayerSelectClick(value, checked)
    });
  };

  handleCollapse = value => () => {
    this.toggleState(value, 'collapsed');
  };

  shouldComponentUpdate() {
    if (this.props.items.length === 0) return false;
    if (!this.initialized) {
      this.initialized = true;
      if (this.props.collapsables && this.props.collapsables.length > 1) {
        this.setState({checked: this.props.collapsables});
        return false;
      }
    }
    return true;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.preselectedLayers && !this.filteredItemsInitialized) {
      this.filteredItemsInitialized = true;
      const selectedKeys = [];
      Object.keys(this.props.preselectedLayers).map(layerId => {
        selectedKeys.push(this.props.layersById[layerId].key);
      });

      this.setState({
        filtered: [0, ...selectedKeys]
      })
    }
  }

  render() {
    const { classes } = this.props;

    const ListItems = function(props) {
      return (<List className={props.nested ? props.listItemClassName : null}>
              {
              
                props.items && props.items.map(item => {
                  const collapsable = item.items && item.items.length>0 && ['SLEPI_IN_SLABOVIDNI', 'GIBALNO_OVIRANI', 'OTROCI'].indexOf(item.codeListKey)!==-1;

                  let collapsed = false;

                  if (item.items && this.props.preselectedLayers && item.items.findIndex(item => this.props.preselectedLayers[item.layerId]!==undefined) !== -1) {
                    collapsed = this.state.collapsed.indexOf(item.key) === -1;
                  }
                  else {
                    collapsed = this.state.collapsed.indexOf(item.key) !== -1;
                  }

                  let checked = false;

                  if (item.layerId && this.props.preselectedLayers && this.props.preselectedLayers[item.layerId]!==undefined) {
                    checked = this.state.checked.indexOf(item.key) === -1;
                    item.filterIcon = true;
                  }
                  else {
                    checked = this.state.checked.indexOf(item.key) !== -1;
                  }

                  let filtered = this.state.filtered.indexOf(item.key) !== -1;

                  const record_count =  filtered ? this.props.preselectedLayers[item.layerId].count : item.record_count;

                  const isSubHeader = !collapsable && item.items && item.items.length>0;
                  return (
                    <span key={item.key}>

                      <ListItem dense button>
                        
                        {(collapsable || !isSubHeader) && <Checkbox
                          checked={checked}
                          disabled={!props.parentChecked}
                          tabIndex={-1}
                          disableRipple
                          onClick={this.handleToggle(item, checked)} 
                        />}

                        {item.additional.icon && <IconButton><img src={'./icons/'+item.additional.icon}/></IconButton>}
                        
                        {
                          isSubHeader ? 
                          <div style={{borderBottom: 'solid 1px', fontWeight:'bold', width:'100%', fontSize:'98%', marginTop:'5px'}}>{item.text}</div>:
                          <ListItemText classes={collapsable ? { primary: classes.bold } : null} primary={item.text} onClick={this.handleCollapse(item)}/>
                        }
                        
                        {item.img && <img src={item.img}/>}
                        
                        {!item.items && <Badge disabled={!props.parentChecked || !checked} onClick={() => this.props.handleLayerAttributes(item.layerId, filtered)} classes={{ badge: classes.badge }} showZero={true} badgeContent={record_count} color="primary"></Badge>}
                        
                        {!item.items && <div style={{display:"flex"}}><IconButton disabled={!props.parentChecked || !checked} aria-label="grid" onClick={() => this.props.handleLayerAttributes(item.layerId, filtered)}><GridIcon/></IconButton>
                        
                        {item.filterIcon && <IconButton onClick={()=> {
                          this.handleFilterToggle(item, filtered, checked);
                        }} style={{marginLeft:'-5px'}}><FilterListIcon className={filtered ? classes.filterOn : null}></FilterListIcon></IconButton>}</div>
                        }
                        
                        {
                          collapsable && ((collapsed ? <ExpandLess onClick={this.handleCollapse(item)} /> : <ExpandMore onClick={this.handleCollapse(item)} />))
                        }

                      </ListItem>

                {collapsable ?
                  <Collapse in={collapsed} timeout="auto" unmountOnExit>
                    <ListItems items={item.items} listItemClassName={classes.nested} nested={true} parentChecked={checked}></ListItems>
                  </Collapse> :
                  isSubHeader && <ListItems items={item.items} listItemClassName={classes.nested} nested={true} parentChecked={props.parentChecked}></ListItems>
                }
                </span>
              )})}
        </List>)
    }.bind(this);

    return <MuiThemeProvider theme={theme}>
            <ListItems items={this.props.items} listItemClassName={classes.nested} nested={false} parentChecked={true}></ListItems>
          </MuiThemeProvider>
  }
}

CheckboxList.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CheckboxList);